import { FC, createContext, useContext, useEffect, useState } from 'react';
import { WithChildren } from '../../app/helper/react18MigrationHelpers';

const I18N_CONFIG_KEY = 'i18nConfig';

type Props = {
  selectedLang: 'en'; // | 'ar';
};

type EventLangChange = {
  detail: 'en'; //| 'ar';
};
const initialState: Props = {
  selectedLang: 'en',
};

export function getConfigI18n(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY);
  if (ls) {
    try {
      return JSON.parse(ls) as Props;
    } catch (er) {
      console.error(er);
    }
  }
  return initialState;
}

// Side effect
export function setLanguage(lang: string) {
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({ selectedLang: lang }));
  window.location.reload();
}

export const I18nContext = createContext<Props>(initialState);

const useLang = () => {
  return useContext(I18nContext).selectedLang;
};

const TazmeenI18n: FC<WithChildren> = ({ children }) => {
  const [lang, setLang] = useState<Props>(getConfigI18n());
  useEffect(() => {
    const handleLanguageChange = (event: unknown) => {
      const eventData = event as EventLangChange;
      setLang({ selectedLang: eventData.detail });
    };
    window.addEventListener('languageChange', handleLanguageChange);

    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  return <I18nContext.Provider value={lang}>{children}</I18nContext.Provider>;
};

export { TazmeenI18n, useLang };
